import { ReactNode } from 'react'
import { MatchPlayType } from '@/types'
import { AdjustmentMatchInput, AdjustmentMatchStub } from './AdjustmentMatch'
import { InformationalMatchStub } from './InformationMatch'
import { MatchStubErrorBoundary } from './MatchStubShell'

export type AdjustmentMatchData = {
  eventName?: string
  match?: AdjustmentMatchInput | null
}

type Props = {
  matchPlayType: MatchPlayType | undefined
  regular: () => ReactNode
  matchDate?: string
  adjustmentData?: AdjustmentMatchData
}

/**
 * Dispatches a match render by its play type. REGULAR delegates to the
 * caller-supplied callback (so its cost is only paid for regular matches).
 * INFORMATIONAL and ADJUSTMENT render their stubs wrapped in an error
 * boundary that falls back to a "Match recorded" card on any render error.
 * Anything else (including undefined) renders nothing.
 */
export function MatchByPlayType({ matchPlayType, regular, matchDate, adjustmentData }: Props) {
  if (matchPlayType === 'REGULAR') return <>{regular()}</>

  if (matchPlayType === 'INFORMATIONAL') {
    return (
      <MatchStubErrorBoundary matchDate={matchDate}>
        <InformationalMatchStub matchDate={matchDate} eventName={adjustmentData?.eventName} />
      </MatchStubErrorBoundary>
    )
  }

  if (matchPlayType === 'ADJUSTMENT') {
    return (
      <MatchStubErrorBoundary matchDate={matchDate}>
        <AdjustmentMatchStub
          matchDate={matchDate}
          eventName={adjustmentData?.eventName}
          match={adjustmentData?.match}
        />
      </MatchStubErrorBoundary>
    )
  }

  return null
}
